import React, {
    useContext
} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { TrackingContext } from '@vrbo/react-event-tracking';
import { Icon } from '@ferris/react';
import EgLogo from '../EgLogo';
import TranslationUtil from '../../utils/TranslationUtil';
import { createInteractionEvent } from '../../utils/EventProviders/EgClickstreamUtil';
import LypCta from '../ListYourPropertyPage/LypHeader/LypCta';
import EgHeaderCta from './cta';
import { DomUtilsCtx } from '../../contexts/domUtils';

export const LypHeader = (props) => {
    const {
        getFooterLinks,
        isRebranded,
        logoText,
        isFrboFlow,
        helpText,
        helpLink,
        lypCtaText
    } = props;

    const {
        isTopOfPage
    } = useContext(DomUtilsCtx);

    const { trigger } = useContext(TrackingContext);

    const triggerClickstream = () => {
        trigger('interaction', createInteractionEvent('contact_us.selected', 'Property Onboarding', ''));
        return true;
    };

    // eslint-disable-next-line react/prop-types
    return (
        <nav
            className={classNames('navbar',
                {
                    'header-scroll-not-top': !isTopOfPage
                })}
        >
            <div
                className={classNames('header')
                }
            >
                <div className="logo">
                    <EgLogo callStatus={getFooterLinks} />
                    {
                        isRebranded && (
                            <span>
                                {logoText}
                            </span>
                        )
                    }
                </div>
                {
                    isRebranded && (
                        <EgHeaderCta />
                    )
                }
                <LypCta
                    lypCtaText={lypCtaText}
                    isRebranded={isRebranded}
                    display={isRebranded && isFrboFlow}
                />
                { (isRebranded && isFrboFlow) && !!helpText && !!helpLink && (
                    <div className="help">
                        <a href={helpLink} onClick={triggerClickstream}>
                            {helpText}
                            <Icon
                                name="help-outline"
                                size="small"
                            />
                        </a>
                    </div>
                )}
            </div>
        </nav>
    );
};

LypHeader.propTypes = {
    // eslint-disable-next-line react/require-default-props
    history: PropTypes.shape({
        replace: PropTypes.func
    }).isRequired,
    getFooterLinks: PropTypes.shape({
        start: PropTypes.bool.isRequired,
        success: PropTypes.bool.isRequired,
        fail: PropTypes.bool.isRequired
    }).isRequired,
    isRebranded: PropTypes.bool.isRequired,
    logoText: PropTypes.string.isRequired,
    isFrboFlow: PropTypes.bool.isRequired,
    helpText: PropTypes.string.isRequired,
    helpLink: PropTypes.string.isRequired,
    lypCtaText: PropTypes.string.isRequired
};

/* istanbul ignore next */
const mapStateToProps = (state) => {
    const { app } = state;
    const {
        footerLinks, getFooterLinks, siteUrls
    } = app;
    const defaultLogo = {
        image: '',
        link: '',
        text: '',
        altText: ''
    };
    const translations = new TranslationUtil(app.translations, app.fallbackTranslations);
    const logoText = translations.getTranslation('lyp.header.logo.text');
    const lypCtaText = translations.getTranslation('valueProposition.header');

    return {
        lypCtaText,
        helpText: translations.getTranslation('lyp.header.help.text'),
        helpLink: siteUrls && siteUrls.lypContactUsUrl ? siteUrls.lypContactUsUrl : '',
        logo: footerLinks && footerLinks.logo ? footerLinks.logo : defaultLogo,
        getFooterLinks,
        logoText
    };
};

const ConnectedLypHeader = connect(mapStateToProps)(LypHeader);
export default ConnectedLypHeader;
